import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-search-tickets',
  templateUrl: './search-tickets.component.html',
  styleUrls: ['./search-tickets.component.css']
})
export class SearchTicketsComponent implements OnInit {

  usersList: any= []
  userId = ""
  startDate = ""
  endDate = ""
  Date1 = ""
  Date2 = ""
  filteredData: any= []
  UserfilteredData: any = []
  ticketdata = false
  userticket = false
  searchticket = false
  cid:any = ""
  AllTickets: any = [];
  customertype:any = ""
  heading:any = ""
  typeId:any = ""
  searchedticketdata:any = []
  status: any = "OPEN"

  constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService) { }

  ngOnInit(): void {
    this.cid = sessionStorage.getItem('cid')
    this.getUsers()
    // this.getAllTickets()
  }
  getUsers(){
    this.generic_service.getUsers().subscribe(
      (res:any)=>{
        this.usersList = res.response;
      }
    )
  }

  filterByTicketStatusAndBetweenDates(){
    let Date1 = new Date(this.Date1).getTime()
    let Date2 = new Date(this.Date2).getTime()
    this.generic_service.filterByTicketStatusAndBetweenDates(this.status,0,10,Date1,Date2).subscribe(
      (response:any)=>{
        console.log(response)
        this.filteredData = []
        this.filteredData = response.response
        this.UserfilteredData = []
        this.searchedticketdata = []
        this.ticketdata = true
        this.userticket = false
        this.searchticket = false
      },
      (error:any)=>{
        console.log(error)
      }
    )
  }


  getFilteredData(){
    let Date1 = new Date(this.Date1).getTime()
    let Date2 = new Date(this.Date2).getTime()
    // this.generic_service.ticketFilterByAndUserIdAndDates(this.userId,Date1,Date2).subscribe(
    //   (response:any)=>{
    //     console.log(response)
    //     this.UserfilteredData = []
    //     this.UserfilteredData = response.response
    //     this.filteredData = []
    //     this.searchedticketdata = []
    //     this.userticket = true
    //     this.ticketdata = false
    //     this.searchticket = false
    //   },
    //   (error:any)=>{
    //     console.log(error)
    //   }
    // )
  }

  addTicketByMultiFieldSearch(){
    let body = 
    {
      "pageNo": 0,
      "recordsPerPage": 10,
      "customerType": this.customertype,
      "cid": this.cid
    }

    console.log(body)
    this.generic_service.addTicketByMultiFieldSearch(body).subscribe(
      (response:any)=>{
        console.log(response)
        this.searchedticketdata = []
        this.searchedticketdata = response.response
        console.log(this.searchedticketdata)
        this.searchticket = true
        this.UserfilteredData = []
        this.filteredData = []
        this.userticket = false
        this.ticketdata = false
      },(err:any)=>{
        console.log(err)
        this.toastr.error(err.error.errors[0].description);

      }
    )
  }

  // getAllTickets(){
  //   this.generic_service.getcontroller().subscribe(
  //     (response:any)=>{
  //       this.AllTickets = response.response;
  //     }
  //   )
  // }
}
